import * as z$1 from "zod/v4";
//#region src/schemas/http/slack-workspace-directory.ts
const ISO_DATE_TIME_SCHEMA = z$1.iso.datetime({ offset: true });
const trimmedNonEmptyStringSchema = z$1.string().trim().min(1);
const nullableTrimmedStringSchema = z$1.union([trimmedNonEmptyStringSchema, z$1.null()]);
const centerAgentReadSlackWorkspaceDirectoryBodySchema = z$1.strictObject({
	cursor: trimmedNonEmptyStringSchema.max(2048).optional(),
	includeMemberUserId: z$1.literal(true).optional(),
	limit: z$1.number().int().min(1).max(200).optional()
});
const slackWorkspaceMembershipSchema = z$1.discriminatedUnion("status", [
	z$1.strictObject({
		matchedBy: z$1.enum(["identity_link", "email"]),
		memberDisplayName: trimmedNonEmptyStringSchema,
		memberUserId: trimmedNonEmptyStringSchema.optional(),
		status: z$1.literal("member")
	}),
	z$1.strictObject({ status: z$1.literal("not_member") }),
	z$1.strictObject({
		reason: z$1.literal("email_unavailable"),
		status: z$1.literal("unknown")
	})
]);
const slackWorkspaceDirectoryMemberSchema = z$1.strictObject({
	displayName: trimmedNonEmptyStringSchema,
	email: nullableTrimmedStringSchema,
	isAdmin: z$1.boolean(),
	isGuest: z$1.boolean(),
	isOwner: z$1.boolean(),
	realName: nullableTrimmedStringSchema,
	slackUserId: trimmedNonEmptyStringSchema,
	title: nullableTrimmedStringSchema,
	openMeldMembership: slackWorkspaceMembershipSchema
});
const slackWorkspaceDirectoryResponseSchema = z$1.strictObject({
	generatedAt: ISO_DATE_TIME_SCHEMA,
	members: z$1.array(slackWorkspaceDirectoryMemberSchema),
	nextCursor: nullableTrimmedStringSchema,
	organizationId: trimmedNonEmptyStringSchema
});
const slackReadUnavailableResponseSchema = z$1.strictObject({
	message: trimmedNonEmptyStringSchema.max(500),
	nextAction: trimmedNonEmptyStringSchema.max(500),
	organizationId: trimmedNonEmptyStringSchema,
	reasonCode: z$1.enum([
		"channel_access_required",
		"connection_state_unavailable",
		"slack_not_connected"
	]),
	status: z$1.literal("unavailable")
});
const centerAgentReadSlackWorkspaceDirectoryResponseSchema = z$1.union([slackWorkspaceDirectoryResponseSchema, slackReadUnavailableResponseSchema]);
//#endregion
export { centerAgentReadSlackWorkspaceDirectoryBodySchema, centerAgentReadSlackWorkspaceDirectoryResponseSchema, slackReadUnavailableResponseSchema, slackWorkspaceDirectoryMemberSchema, slackWorkspaceDirectoryResponseSchema, slackWorkspaceMembershipSchema };

//# sourceMappingURL=slack-workspace-directory.js.map